import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";


const AssignProperty = () => {

    const [properties, setProperties] = useState([]);
    const [selectedPropertyId, setSelectedPropertyId] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingProAss, setLoadingProAss] = useState(false);
    const [productId, setProductId] = useState("");

    const navigate = useNavigate();
    // const location = useLocation();
    const location = useLocation();
    const { productByRow } = location.state || {};

    useEffect(() => {
        if (productByRow) {
            // console.log("product row data", productByRow);
            setName(productByRow.name);
            setProductId(productByRow.product_id);
        }
    }, [productByRow]);

    // ----------------- get all properties here--------------
    useEffect(() => {
        const fetchAllProperties = async () => {
            setLoading(true);
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                const token = authData?.token;
                if (!token) {
                    throw new Error("No access token found.");
                }

                const response = await axios.get(ApiServices.getProductProperty, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    withCredentials: true,
                });


                const { status, message, data } = response.data;
                // console.log("these are all the product properties", response.data);
                // return;
                if (status === 200) {
                    setProperties(data.properties);
                } else {
                    handleError({ response: { status, data: { message } } }, navigate);
                }
            } catch (error) {
                handleError(error, navigate);
            } finally {
                setLoading(false);
            }
        };

        fetchAllProperties();
    }, []);

    //axios api encryption call
    const axios = AxiosApiCall();


    const validateForm = () => {
        if (!productId || !selectedPropertyId || selectedOptions.length === 0) {
            toast.error("Please select a property and at least one option.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoadingProAss(true);

        const formData = {
            product_id: productId,
            property_id: Number(selectedPropertyId),
            value: selectedOptions,
        };
        // console.log("form data", formData);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.post(
                ApiServices.assignProperty,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === 200) {
                navigate("/admin/products");
                toast.success(message);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoadingProAss(false);
        }
    };


    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section
                        className="w-full  pr-[3%] pt-3 my-3"
                        style={{ backgroundColor: "#F7F7F7" }}
                    >
                        <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                            <ol className="list-none p-0 inline-flex mb-2">
                                <li className="flex items-center">
                                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                        Product Property
                                    </p>
                                    <ChevronRightIcon />
                                </li>
                                <li className="flex items-center">
                                    <p className="text-orange1">Create</p>
                                </li>
                            </ol>
                        </nav>
                    </section>

                    <section className="gray_background">
                        <div className="container px-1 pb-2 mx-auto">
                            <div className="lg:w-full md:w-full bg-white rounded-lg py-3 px-2 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        <div className="w-full">
                                            <label
                                                htmlFor="name"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Product  Name
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={name}
                                                readOnly
                                                className="border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                placeholder="Enter  name"
                                            />
                                        </div>
                                        <div className="w-full">
                                            <label
                                                htmlFor="unit"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Product Properties
                                            </label>
                                            <select
                                                id="properties"
                                                value={selectedPropertyId}
                                                onChange={(e) => {
                                                    setSelectedPropertyId(e.target.value);
                                                    setSelectedOptions([]); // reset when new property chosen
                                                }}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                                required
                                            >
                                                <option value="">-- Select Property --</option>
                                                {properties.map((property) => (
                                                    <option key={property.property_id} value={property.property_id}>
                                                        {property.name.replace(/_/g, " ")}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>

                                    </div>
                                    {selectedPropertyId && (
                                        <div className="mt-4">
                                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Options
                                            </label>
                                            <div className="flex flex-wrap gap-4">
                                                {properties.find((p) => String(p.property_id) === String(selectedPropertyId))
                                                    ?.options.map((opt, idx) => (
                                                        <label key={idx} className="flex items-center space-x-2">
                                                            <input
                                                                type="checkbox"
                                                                value={opt}
                                                                checked={selectedOptions.includes(opt)}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setSelectedOptions([...selectedOptions, opt]);
                                                                    } else {
                                                                        setSelectedOptions(selectedOptions.filter((o) => o !== opt));
                                                                    }
                                                                }}
                                                                className="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500"
                                                            />
                                                            <span>{opt}</span>
                                                        </label>
                                                    ))}
                                            </div>
                                        </div>
                                    )}



                                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                                        <Link
                                            to="/admin/products"
                                            className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                                        >
                                            <List className="mr-2" />
                                            Back To List
                                        </Link>
                                        <button
                                            type="submit"
                                            className={`text-white bg-darkGreen3 text-dGrey3 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"
                                                }`}
                                            disabled={loadingProAss}
                                        >
                                            {loadingProAss ? "Assigning..." : "Add Property to product"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default AssignProperty;
